<template>

	<div>
		<!-- <MyBread v-bind:BreadcrumbList="BreadcrumbList"></MyBread> -->
		<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
			<FormItem prop="trackName" :label="$tt('运营商')" :label-width="60">
				<Select filterable clearable style="width: 120px;" v-model="formInline.OperatorId">
					<Option v-bind:key="item.Id" v-for="(item) in OperatorList" :value="item.Id">{{item.Name}}</Option>
					<!-- <span slot="prepend">{{$tt('联系电话')}}</span> -->
				</Select>
			</FormItem>
			<FormItem prop="trackName" :label="$tt('充电站名称')" :label-width="85">
				<Input type="text" v-model="formInline.StationName" :placeholder="$tt('充电站名称')" />
			</FormItem>
			<FormItem>
				<Button type="primary" @click="handleSubmit('formInline')" v-if="hasWidgets('search')">{{$tt('查询')}}</Button>
			</FormItem>
			<div style="float: right;">
				<Button type="primary" @click="show('addStation')" v-if="hasWidgets('add')">{{$tt('场站添加')}}</Button>
				<!-- <Button style="float: left;margin-left: 5px;" type="primary" @click="show('addExcel')">{{$tt('批量导入')}}</Button> -->
			</div>
		</Form>
		<!-- <Table :columns="columns1" :data="data1" :height="tableHeight" size="small">
			<div slot="footer"><MyPage ref="sonPage" :param="pageParam" :url="getStationInfoUrl" @listData='getDeviceData'></MyPage></div>
		</Table> -->
		<PageTable ref="table" :columns="columns1" :tableHeight="tableHeight" :url="getStationInfoUrl" :queryParam="pageParam"></PageTable>
		<Modal :mask-closable="false" @on-cancel="cancelPictures" v-model="modalView" :title="modal.Title" width="40%">
			<!--设备安装和设备修改-->
			<Form label-position="right" :rules="ruleInline"
				v-if="modal.type=='addStation'||modal.type=='updateStation'||modal.type=='viewStation'" ref="StationForm"
				:model="StationForm" :label-width="120">
				<FormItem :label="$tt('场站编码')" prop="StationCode" v-show="false">
					<Input :disabled="ifup" v-model="StationForm.StationCode" :placeholder="$tt('输入场站编码')"></Input>
				</FormItem>
				<FormItem :label="$tt('充电站名称')" prop="StationName">
					<Input :disabled="ifViewStation" v-model="StationForm.StationName" :placeholder="$tt('输入充电站名称')"></Input>
				</FormItem>
				<!-- <FormItem :label="$tt('运营商ID')" prop="OperatorId" v-show="false">
					<Input :disabled="ifAddStation" v-model="StationForm.OperatorId" :placeholder="$tt('输入运营商ID')"></Input>
				</FormItem> -->
				<FormItem :label="$tt('所属运营商')" prop="OperatorId">
					<Select filterable :disabled="ifViewStation" :placeholder="$tt('运营商名称')"
						v-model="StationForm.OperatorId">
						<Option v-bind:key="itemIndex" v-for="(item,itemIndex) in OperatortypeList" :value="item.Id">{{item.Name}}</Option>
					</Select>
				</FormItem>
				<FormItem :label="$tt('服务电话')" prop="ServiceTel">
					<Input :disabled="ifViewStation" v-model="StationForm.ServiceTel" :placeholder="$tt('输入服务电话')"></Input>
				</FormItem>
				<FormItem :label="$tt('详细地址')" prop="Address">
					<Input :disabled="ifViewStation" v-model="StationForm.Address" :placeholder="$tt('输入详细地址')"></Input>
				</FormItem>
				<FormItem :label="$tt('站点属性')" prop="StationProperty" v-show="false">
					<Select :disabled="ifViewStation" :placeholder="$tt('运营场站的属性')" v-model="StationForm.StationProperty">
						<Option :value="1">{{$tt('汽车充电站')}}</Option>
						<Option :value="2">{{$tt('电单车充电站')}}</Option>
					</Select>
				</FormItem>
				<FormItem :label="$tt('设备前置')" prop="ChargeFronter" v-show="false">
					<Select :disabled="ifViewStation" :placeholder="$tt('设备前置所属前置机')" v-model="StationForm.ChargeFronter">
						<Option v-bind:key="item.Id" v-for="(item) in ChargeFronterList" :value="item.Id"> {{item.Name}}</Option>
					</Select>
				</FormItem>
			</Form>
			<div v-if="modal.type=='addStation'" slot="footer">
				<Button v-if="modal.type!='install'" type="warning" size="large" @click="modalCancel">{{$tt('重置')}}</Button>
				<Button type="success" size="large" @click="modalOk('add')">{{$tt('新增')}}</Button>
			</div>
			<div v-if="modal.type=='updateStation'" slot="footer">
				<Button type="success" size="large" @click="modalOk('up')">{{$tt('确认修改')}}</Button>
			</div>
			<div v-if="modal.type=='viewStation'" slot="footer">
			</div>
		</Modal>
	</div>
</template>

<script>
	import dateFormat from '../../../../public/js/comm.js'
	import Qs from 'qs'
	import expandRow from './StationManagementExpand.vue';
	// import gaodeMap from '../../../js/GaodeMapMethod.js'
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import webapi from '../../../webapi.js';
	import commonFuncs from '../../../js/commonFuncs.js';
	import PageTable from '../../public/PageTable/PageTable.vue';
	export default {
		components: {
			PageTable
		},
		data() {
			return {
				getStationInfoUrl: webapi.base_api_url + '/Archives/GetStationInfo',
				uploadImageUrl: webapi.base_api_url + '/Common/UploadImage',
				occupyPriceList: [],
				zindex: 2000,
				loadingStatus: false,
				//model表单
				params: "", //table 传参
				//选择展示的充电站
				SelectStation: "有家充电站",
				tableHeight: "650",
				modal: {
					Title: this.$tt('场站添加'),
					type: "addStation"
				},
				modalView: false,

				//图片上传组件数据
				defaultList: [],
				upHeader: {
					'Authorization': "Bearer " + encodeURIComponent(localStorage.AccessToken)
				},
				imgName: '',
				visible: false,
				uploadList: [],
				//新增图片删除缓存，实际点击保存才删除
				PictureDelCache: [],
				//原始图片删除缓存
				PictureUpCache: [],
				/******分割线********/

				//地图modal
				center: [114.198595, 22.633595],
				showMap: false,
				inputCity: '深圳',
				//字段显示
				ifAddStation: true,
				//修改主键只能查
				ifup: false,
				//场站信息是否只能查看
				ifViewStation: false,

				showMechant: false,
				showEvcs: false,

				EvcsOperators: [],
				//档案-场站管理全部信息
				StationForm: {
					//前八个是某系整数结果代表什么意思的描述  用来配合显示
					StationTypeDesc: "公共",
					StationStatusDesc: "正常使用",
					StationPicturesArray: [],
					ConstructionDesc: "大型建筑配建停车场",
					ParkOpratorTypeDesc: "由本运营商自营",
					EvcsOperatorArray: [],
					Creator: "",
					Modifier: "",

					EquipmentNum: 0,
					ConnectorNum: 0,

					Id: 0,
					StationCode: "",
					StationName: "",
					OperatorId: "",
					OperatorName: "",
					EquipmentOwnerId: "",
					CountryCode: "",
					AreaCode: "",
					Address: "",
					StationTel: "",
					ServiceTel: "",
					StationType: 1,
					StationProperty: 1,
					ChargeFronter: 1,
					StationStatus: 50,
					ParkNum: 0,
					Longitude: 0,
					Latitude: 0,
					SiteGuide: "",
					Construction: 9,
					StationPictures: "",
					MatchCar: "",
					ParkInfo: "",
					BusinessHours: "00:00-24:00",
					ElectricityFee: "",
					ServiceFee: "",
					ParkFee: "",
					PaymentMode: 34,
					SupportOrder: 0,
					QueryType: 8,
					Remark: "",
					ParkOwner: "",
					ParkManager: "",
					ParkOpenAllDay: 1,
					ParkFree: 0,
					ParkOpratorType: 1,
					IsOpen: 1,
					IsScanCode: 1,
					SupportWalletPayment: 0,
					DisparkDate: "",
					CollectionMch: 0,
					EvcsOperators: "",
					CreateBy: 0,
					CreateTime: "",
					ModifyBy: 0,
					ModifyTime: ""
				},
				StationMerchantForm: {},
				StationEvcsForm: {},
				//校验字段
				ruleInline: {
					StationName: [{
						required: true,
						message: this.$tt('请输入充电站名称'),
						trigger: 'blur'
					}],
					OperatorId: [{
						required: true,
						message: this.$tt('运营商不能为空'),
						trigger: 'change',
					}],
				// 	StationTel: [{
				// 		required: true,
				// 		message: this.$tt('请输入负责人电话'),
				// 		trigger: 'blur'
				// 	}],
				// 	ServiceTel: [{
				// 		required: true,
				// 		message: this.$tt('请输入服务电话'),
				// 		trigger: 'blur'
				// 	}],
				// 	StationType: [{
				// 		required: true,
				// 		message: this.$tt('站点类型'),
				// 		trigger: 'change',
				// 		type: 'number'
				// 	}],
				// 	StationProperty: [{
				// 		required: true,
				// 		message: this.$tt('站点属性'),
				// 		trigger: 'change',
				// 		type: 'number'
				// 	}],
				// 	ChargeFronter: [{
				// 		required: true,
				// 		message: this.$tt('设备前置'),
				// 		trigger: 'charge',
				// 		type: 'number',
				// 		min: 1,
				// 	}],
				// 	OperatorName: [{
				// 		required: true,
				// 		message: this.$tt('供应商名称'),
				// 		trigger: 'change',
				// 	}],
				// 	AreaCode: [{
				// 		required: true,
				// 		message: this.$tt('请输入行政区域编码'),
				// 		trigger: 'blur'
				// 	}],
				// 	Address: [{
				// 		required: true,
				// 		message: this.$tt('请输入详细地址'),
				// 		trigger: 'blur'
				// 	}],
				// 	Longitude: [{
				// 		required: true,
				// 		message: this.$tt('经度'),
				// 		trigger: 'blur',
				// 		type: 'number',
				// 	}],
				// 	Latitude: [{
				// 		required: true,
				// 		message: this.$tt('纬度'),
				// 		trigger: 'blur',
				// 		type: 'number'
				// 	}],
				// 	BusinessHours: [{
				// 		required: true,
				// 		message: this.$tt('营业时间'),
				// 		trigger: 'blur'
				// 	}]
				},
				BreadcrumbList: [this.$tt('档案管理'), '>>', this.$tt('场站管理')],
				formInline: {
					OperatorId: '',
					StationId: 0,
					StationName: '',
				},
				operateColumnWidth: 30,

				//table标题数据
				columns1: [{
						title: this.$tt('站点名称'),
						key: 'StationName',
						minWidth: 150
					}, {
						title: this.$tt('详细地址'),
						key: 'Address',
						minWidth: 200
					},
					{
						title: this.$tt('设备数量'),
						key: 'EquipmentNum',
						minWidth: 100
					},
					// {
					// 	title: '枪口数量',
					// 	key: 'ConnectorNum',
					// 	minWidth: 100
					// },
					{
						title: this.$tt('站点状态'),
						key: 'StationStatus',
						minWidth: 100,
						render: (h, params) => {
							return h('div',
								this.$tEnum('StationStatus', params.row.StationStatus, params.row.StationStatusDesc)
							);
						}
					},
					{
						title: this.$tt('服务电话'),
						key: 'ServiceTel',
						minWidth: 120
					},
					{
						title: this.$tt('运营商名称'),
						key: 'OperatorName',
						minWidth: 200
					}, {
						title: this.$tt('操作'),
						key: 'action',
						minWidth: 200,
						align: 'center',
						render: (h, params) => {
							return h('div', [
								this.hasWidgets('edit') ? h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px',
									},
									on: {
										click: () => {
											this.show("updateStation", params.row)
										}
									}
								}, this.$tt('修改')) : h(),
								this.hasWidgets('view') ? h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										//为了不误操作，确定取消相反
										click: () => {
											this.show("viewStation", params.row)
										}
										// this.show("deleteStation", params.row.Id)
									}
								}, this.$tt('查看')) : h(),
								this.methodList.filter(item => this.hasWidgets(item.name)).length > 0 ? h(
									'Dropdown', {
										on: {
											//为了不误操作，确定取消相反
											'on-click': (name) => {
												this.$Modal.confirm({
													title: name,
													okText: this.$tt('取消'),
													cancelText: this.$tt('确定'),
													onCancel: () => {
														this.otherMethodStation(name,
															params.row.Id);
													}
												});
												// this.show("deleteStation", params.row.Id)
											}
										}
									},
									[
										h('Button', {
											props: {
												type: 'primary',
												size: 'small',
											},
											style: {
												marginRight: '5px'
											},
										}, this.$tt('其他操作')),
										h('DropdownMenu', {
											slot: 'list'
										}, [
											this.methodList.filter(item => this.hasWidgets(item.name))
											.map((
												item) => { // this.productTypeList下拉框里的data
												return h('DropdownItem', {
														props: {
															name: item.Status
														}
													},
													item.Status
												)
											})
										])
									],
								) : h()
							]);
						}
					}
				],
				methodList: [{
						id: 0,
						name: 'assignMerchant',
						Status: this.$tt('分配收款商户')
					}, {
						id: 0,
						name: 'assignEvcs',
						Status: this.$tt('分配互联互通')
					},
					{
						id: 1,
						name: 'building',
						Status: this.$tt('建设中')
					}, {
						id: 5,
						name: 'swithcOff',
						Status: this.$tt('关闭下线')
					},
					{
						id: 6,
						name: 'maintaining',
						Status: this.$tt('维护中')
					},
					{
						id: 50,
						name: 'running',
						Status: this.$tt('正常使用'),
					}
				],
				data1: [],

				payValue: 0,
				widgets: [],
			};
		},
		async created() {
			const _this = this;
			// _this.tableHeight = window.innerHeight - 160;
			_this.getTableHeight();
			window.addEventListener('resize', this.getTableHeight);
			// this.widgets = this.$route.meta.widgets;// await commonFuncs.getWidgetByMenuId(this.$route.meta.menuId);
			// this.widgets.push({Name: 'edit'});
			// this.widgets.push({Name: 'view'});
			// this.widgets.push({Name: 'running'});
			// console.log('widgets', this.widgets);
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			this.operateColumnWidth = Math.max(60, (36 + (this.hasWidgets('edit') ? 60 : 0) + (this.hasWidgets('view') ?
					60 : 0) +
				(this.methodList.filter(item => this.hasWidgets(item.name)).length > 0 ? 80 : 0)));
			// 不用 .at(-1)：Array.prototype.at 是 ES2022 方法，老浏览器（Chrome < 92 / Safari < 15.4）不支持
			this.columns1[this.columns1.length - 1].minWidth = this.operateColumnWidth;
			this.handleSubmit();
			//this.uploadList = this.$refs.upload.fileList;
			this.GetChargeFronterList();
			// this.getEvcsOperatorList();
			// this.getOccupyPriceList();
			// console.log("useRoute", , this.$router.currentRoute, this.$route, this.$router);
		},
		computed: {
			pageParam: function() {
				const _this = this;
				const param = _this.formInline;
				return param
			},
			PayMethod1: {
				get() {
					let pay = this.StationForm.PaymentMode.toString(2);
					while (pay.length < 6) {
						pay = '0' + pay;
					}
					console.log(pay)
					console.log(pay.substring(5, 6))
					return Number(pay.substring(5, 6))
				},
				set(value) {
					if (value == 0) {
						this.StationForm.PaymentMode = this.StationForm.PaymentMode - 1;
					} else {
						this.StationForm.PaymentMode = this.StationForm.PaymentMode + 1;
					}
				}
			},
			PayMethod2: {
				get() {
					let pay = this.StationForm.PaymentMode.toString(2);
					while (pay.length < 6) {
						pay = '0' + pay;
					}
					return Number(pay.substring(4, 5))
				},
				set(value) {
					if (value == 0) {
						this.StationForm.PaymentMode = this.StationForm.PaymentMode - 2;
					} else {
						this.StationForm.PaymentMode = this.StationForm.PaymentMode + 2;
					}
				}
			},
			PayMethod3: {
				get() {
					let pay = this.StationForm.PaymentMode.toString(2);
					while (pay.length < 6) {
						pay = '0' + pay;
					}
					return Number(pay.substring(1, 2))
				},
				set(value) {
					if (value == 0) {
						this.StationForm.PaymentMode = this.StationForm.PaymentMode - 16;
					} else {
						this.StationForm.PaymentMode = this.StationForm.PaymentMode + 16;
					}
				}
			},
			PayMethod4: {
				get() {
					let pay = this.StationForm.PaymentMode.toString(2);
					while (pay.length < 6) {
						pay = '0' + pay;
					}
					return Number(pay.substring(0, 1))
				},
				set(value) {
					if (value == 0) {
						this.StationForm.PaymentMode = this.StationForm.PaymentMode - 32;
					} else {
						this.StationForm.PaymentMode = this.StationForm.PaymentMode + 32;
					}
				}
			},

			//直接选属性
			...mapState({
				StationList: 'Stations',
				OperatortypeList: 'typeList',
				ChargeFronterList: 'chargeFronterList',
				PayeeMerchant: 'PayeeMerchant',
				OperatorList: 'typeList',
			})
		},
		methods: {
			...mapActions([
				'GetUserStations',
				'GetChargeFronterList'
			]),
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			//操作按钮
			show: function(type, params) {
				this.$refs.StationForm.resetFields();
				switch (type) {
					case "addStation":
						this.modal.type = "addStation";
						this.modal.Title = this.$tt('场站添加');
						this.ifup = false
						this.ifViewStation = false
						this.modalCancel();
						break;
					case "updateStation":
						this.modal.type = "updateStation";
						this.modal.Title = this.$tt('场站信息修改');
						this.ifup = true
						this.getUpdateMessage(params);
						this.ifViewStation = false
						break;
					case "viewStation":
						this.modal.type = "viewStation";
						this.modal.Title = this.$tt('场站信息查看');
						this.getUpdateMessage(params);
						this.ifup = true
						this.ifViewStation = true
						break;
				}
				this.modalView = true;

			},
			//modal取消操作
			cancelPictures: function() {
				const _this = this
				_this.PictureUpCache = []
				if (_this.PictureDelCache.length > 0) {
					console.log("取消添加或跟新，删除添加的图片")
					let picsArr = _this.PictureDelCache
					let StationPictures = ''
					for (let i = 0; i < picsArr.length; i++) {
						if (i == (picsArr.length - 1)) {
							StationPictures += picsArr[i]
						} else {
							StationPictures += picsArr[i] + ','
						}
					}
					_this.deletePicture(StationPictures)
				}
			},
			//删除修改之外的其他操作
			otherMethodStation: function(name, Id) {
				let typeNum = (this.methodList.filter(function(item, index, arr) {
					return item.Status == name
				})[0]).id
				console.log(typeNum)
				this.$axios.post(webapi.SetStationStatus, {
					Id: Id,
					Status: typeNum
				}).then(res => {
					if (res.data.Code == 0) {
						this.$Message.info(name + this.$tt('成功'));
						this.handleSubmit()
					}
				})
			},
			deleteStation: function() {
				const _this = this;
				_this.$axios.post(webapi.base_api_url + "/Overview/###", {}).then(res => {
					if (res.data.code != 1 && res.data.Data != null) {
						this.$Message.info(this.$tt('删除成功'));
					}
				})
			},
			getDeviceData: function(data) {
				console.log(data)
				this.data1 = data.Data.List
			},
			handleSubmit: function() {
				if (!this.hasWidgets('search')) return;
				// this.$refs.sonPage.getList();
				this.$refs.table.getData();
				// const _this = this;
				// let parms = _this.formInline;
				// _this.$axios.post(webapi.base_api_url + "/Order/GetChargeOrder", parms, {
				// }).then(res => {
				// 	console.log("res")
				// 	console.log(res.data)
				// 	if (res.data.Code == 0) {
				// 		_this.data1 = res.data.Data.AlarmingInfos;
				// 	}
				// })
			},

			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 160 - (window.innerWidth < 764 ? 40 : 0);
			},
			modalCancel: function() {
				this.uploadList = []
				this.$nextTick(() => {
					this.$refs.StationForm.resetFields();
					// this.$refs.upload.clearFiles();
					// this.defaultList = this.$refs.upload.fileList
				})
			},
			deepClone(params) {
				// 如果数组类型数据
				if (Array.isArray(params)) {
					let newnew = []
					for (let i = 0; i < params.length; i++) {
						newnew[i] = this.deepClone(params[i]) // 递归调用克隆
					}
					return newnew // 克隆完以后，再返回出结果
				}
				// 如果是对象类型数据
				if (Object.prototype.toString.call(params) === '[object Object]') {
					let newnew = {}
					for (const key in params) {
						newnew[key] = this.deepClone(params[key]) // 递归调用克隆
					}
					return newnew // 克隆完以后，再返回出结果
				}
				// 如果是普通数据类型
				return params
			},
			getUpdateMessage: function(params) {
				const _this = this;
				if (params) {
						_this.StationForm = _this.deepClone(params);
						// let picList = [];
						// let arr = params.StationPicturesArray
						// for (let i = 0; i < arr.length; i++) {
						// 	let url = ''
						// 	// if (process.env.NODE_ENV === "development") {
						// 	// 	url = 'http://'+window.location.href.split("/")[2]+'/ChargePlatform'+arr[i];
						// 	// }else {
						// 	//   url = 'https://'+window.location.href.split("/")[2]+'/ChargePlatform'+arr[i];
						// 	// }
						// 	url = webapi.base_api_url + arr[i];
						// 	let picture = {
						// 		name: arr[i],
						// 		url: url
						// 	}
						// 	picList.push(picture)
						// }
						// _this.defaultList = picList
						// _this.$nextTick(() => {
						// 	// dom元素更新后执行，因此这里能正确打印更改之后的值
						// 	_this.uploadList = _this.$refs.upload.fileList
						// })
				}
				
				// console.log(Id);
				// for (let i = 0; i < _this.data1.length; i++) {
				// 	if (_this.data1[i].Id == Id) {
				// 	}
				// }
			},
			//新增||修改
			modalOk: function(type) {
				const _this = this
				switch (type) {
					case "add":
						_this.StationForm.Id = 0
						break;
					case "up":
						// let picsArr = _this.PictureUpCache
						// if (picsArr.length > 0) {
						// 	let StationPictures = ''
						// 	for (let i = 0; i < picsArr.length; i++) {
						// 		if (i == (picsArr.length - 1)) {
						// 			StationPictures += picsArr[i]
						// 		} else {
						// 			StationPictures += picsArr[i] + ','
						// 		}
						// 	}
						// 	_this.deletePicture(StationPictures)
						// }
						break;
				}
				// _this.PictureDelCache = [];
				// _this.PictureUpCache = [];
				// let picsArr = _this.StationForm.StationPicturesArray
				// _this.StationForm.StationPictures = ''
				// for (let i = 0; i < picsArr.length; i++) {
				// 	if (i == (picsArr.length - 1)) {
				// 		_this.StationForm.StationPictures += picsArr[i]
				// 	} else {
				// 		_this.StationForm.StationPictures += picsArr[i] + ','
				// 	}
				// }
				const param = _this.StationForm
				this.$refs.StationForm.validate((valid) => {
					console.log("场站" + type + "----" + valid)
					if (valid) {
						_this.$axios.post(webapi.base_api_url + '/Archives/AddStation',
							param
						).then(res => {
							console.log(res)
							if (res.data.Code == 0) {
								this.$Message.info(this.$tt('场站') + type + this.$tt('成功'));
								// this.$refs.sonPage.getList();
								this.$refs.table.getData();
								this.modalView = false;
								this.GetUserStations()
							} else {
								this.$Message.info(this.$tt('场站') + type + this.$tt('失败'));
							}
						})
					}
				})
			},

			//地图modal
			// mapOpen: function() {
			// 	this.showMap = true;
			// 	let latlng = [this.StationForm.Longitude, this.StationForm.Latitude]
			// 	this.$nextTick(() => {
			// 		gaodeMap.initMap("map", 9, this.center, 'normal');
			// 		gaodeMap.mapOn2(this);
			// 		gaodeMap.createMarke(latlng)
			// 		if (this.StationForm.Latitude != 0) {
			// 			gaodeMap.map.setCenter(latlng)
			// 		}
			// 	})
			// },
			// closeMap: function() {
			// 	gaodeMap.map.destroy();
			// 	gaodeMap.map = '';
			// 	this.showMap = false;
			// },
			// searchCity: function() {
			// 	const _this = this
			// 	gaodeMap.geoCode(_this.inputCity).then(res => {
			// 		_this.StationForm.Latitude = res.getLat()
			// 		_this.StationForm.Longitude = res.getLng()
			// 		gaodeMap.mapOn2(_this)
			// 		gaodeMap.createMarke(res)
			// 		gaodeMap.map.setCenter(res)
			// 		//console.log(res)
			// 	})
			// },
			deletePicture: function(pictureStr) {
				const _this = this
				_this.$axios.post(webapi.base_api_url + "/Common/DeleteImage", {
					FilePath: pictureStr
				}).then(res => {
					if (res.data.Code == 0) {
						_this.$Message.info(this.$tt('删除成功'));
						_this.PictureDelCache = []
						_this.handleSubmit()
					} else {
						_this.$Message.info(this.$tt('图片删除失败'));
						_this.handleSubmit()
					}
				})
			},
			/**********图片组件方法*************/
			handleView(name) {
				this.imgName = name;
				this.visible = true;
			},
			handleRemove(file) {
				const _this = this
				if (_this.PictureDelCache.indexOf(file.name) > 0) {
					console.log('删除缓存中存在')
				} else {
					console.log('删除缓存中不存在，是原有图片删除')
					_this.PictureUpCache.push(file.name)
				}
				const fileList = _this.$refs.upload.fileList;
				_this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
				_this.$nextTick(() => {
					// dom元素更新后执行，因此这里能正确打印更改之后的值
					console.log(fileList)
					console.log(_this.$refs.upload.fileList)
					_this.uploadList = _this.$refs.upload.fileList
					_this.defaultList = _this.$refs.upload.fileList
				})
				_this.StationForm.StationPicturesArray = _this.StationForm.StationPicturesArray.filter(function(item,
					index,
					arr) {
					console.log(file.name)
					return item != file.name
				})
			},
			handleSuccess(res, file) {
				if (res.Code == 0) {
					// if (process.env.NODE_ENV === "development") {
					// 	file.url = 'http://'+window.location.href.split("/")[2]+'/ChargePlatform'+res.Data;
					// }else {
					//   file.url = 'https://'+window.location.href.split("/")[2]+'/ChargePlatform'+res.Data;
					// }
					file.url = webapi.base_api_url + res.Data.List[0];
					file.name = res.Data.List[0];
					let itemLen = this.defaultList.length;
					this.$set(this.defaultList, itemLen, file);
					this.uploadList = this.defaultList
					this.StationForm.StationPicturesArray.push(file.name)
					this.PictureDelCache.push(file.name)
				}
				//file.url = 'https://o5wwk8baw.qnssl.com/7eb99afb9d5f317c912f08b5212fd69a/avatar';
				//file.name = '7eb99afb9d5f317c912f08b5212fd69a';
			},
			handleFormatError(file) {
				this.$Notice.warning({
					title: this.$tt('格式错误'),
					desc: '请选择 jpg or png.'
				});
			},
			handleMaxSize(file) {
				this.$Notice.warning({
					title: this.$tt('图片太大'),
					desc: '文件' + file.name + this.$tt(' 图片太大请选择小于 2M.')
				});
			},
			handleBeforeUpload() {
				const check = this.uploadList.length < 5;
				if (!check) {
					this.$Notice.warning({
						title: 'Up to five pictures can be uploaded.'
					});
				}
				return check;
			},
			// OperatorNameChange: function(a) {
			// 	const Operatortype = this.OperatortypeList.filter(function(item, index, arr) {
			// 		return item.Name == a
			// 	})
			// 	if (Operatortype && Operatortype.length > 0)
			// 		this.StationForm.OperatorId = Operatortype[0].Id;
			// 	else
			// 		this.StationForm.OperatorId = '';
			// },
			// getEvcsOperatorList: function() {
			// 	this.$axios.post(webapi.base_api_url + '/Common/GetEvcsOperatorList').then(res => {
			// 		if (res.status == 200 && res.data.Code == 0) {
			// 			this.EvcsOperators = res.data.Data.List;
			// 		}
			// 	})
			// },
			assignMerchant: function() {
				const _this = this;
				console.log(this.StationMerchantForm);
				const param = {
					StationId: this.StationMerchantForm.Id,
					MerchantId: this.StationMerchantForm.CollectionMch,
				};
				this.$axios.post(webapi.base_api_url + '/Archives/AssignMerchant', param).then(res => {
					if (res.status == 200 && res.data.Code == 0) {
						_this.handleSubmit();
						_this.$Message.info(this.$tt('分配成功'));
					} else {
						_this.$Message.info(this.$tt('分配失败'));
					}
				});
			},
			assignEvcs: function() {
				const _this = this;
				console.log(this.StationEvcsForm);
				const param = {
					StationId: this.StationEvcsForm.Id,
					EvcsOperatorIds: this.StationEvcsForm.EvcsOperatorArray,
				};
				this.$axios.post(webapi.base_api_url + '/Archives/AssignEvcs', param).then(res => {
					if (res.status == 200 && res.data.Code == 0) {
						_this.handleSubmit();
						_this.$Message.info(this.$tt('分配成功'));
					} else {
						_this.$Message.info(this.$tt('分配失败'));
					}
				});
			},
			getOccupyPriceList: function() {
				const _this = this;
				this.$axios.post(webapi.base_api_url + '/Common/GetSelctListByType', {
					Type: 9
				}).then(res => {
					if (res.status == 200 && res.data.Code == 0) {
						_this.occupyPriceList = res.data.Data.List;
					}
				});
			}
		},
	}
</script>

<style>
	/* 	#tree{
		width: 1200px;
		height: 600px;
		margin-top: 7%;
		border: 2px solid red;
	} */

	.ivu-tag-dot {
		border: 0px solid #e8eaec !important;
	}

	.ivu-form-item {
		margin-bottom: 16px;
	}

	.ivu-form-item-error-tip {
		padding-top: 0;
	}

	/* 	.ivu-col {
		display: flex;
		flex-direction: column;
		justify-content: center;
		justify-items: center;
	}
 */
	.ivu-col-span-7 {
		margin-left: 2%;
	}

	.demo-upload-list {
		display: inline-block;
		width: 60px;
		height: 60px;
		text-align: center;
		line-height: 60px;
		border: 1px solid transparent;
		border-radius: 4px;
		overflow: hidden;
		background: #fff;
		position: relative;
		box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
		margin-right: 4px;
	}

	.demo-upload-list img {
		width: 100%;
		height: 100%;
	}

	.demo-upload-list-cover {
		display: none;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background: rgba(0, 0, 0, .6);
	}

	.demo-upload-list:hover .demo-upload-list-cover {
		display: block;
	}

	.demo-upload-list-cover i {
		color: #fff;
		font-size: 20px;
		cursor: pointer;
		margin: 0 2px;
	}
</style>
